import { ArrayUtility, DataBaseModelInterface } from '@solcre-org/core';
import { DateUtility } from '@solcre-org/core-ui';
import { AuditLogChangeModel } from './audit-log-change.model';

export class AuditLogModel implements DataBaseModelInterface {
  public changes: AuditLogChangeModel[] = [];

  constructor(
    public id?: any,
    public action?: string,
    public entity?: string,
    public entityId?: string,
    public timestamp?: string,
    public user?: string
  ) {}

  public fromJSON(json: any): AuditLogModel {
    if (json) {
      this.id = json.id;
      this.action = json.action;
      this.entity = json.entity;
      this.entityId = json.entityId;
      this.timestamp = DateUtility.fromUTCtoUruguay(
        json.timestamp,
        'DD/MM/YYYY HH:mm'
      );
      this.user = json.user;
      this.changes = [];

      ArrayUtility.each(json.changes, (change: any) => {
        const changeObj: AuditLogChangeModel = new AuditLogChangeModel();
        changeObj.fromJSON(change);
        this.changes.push(changeObj);
      });
    }
    return this;
  }

  public fromJSONList(json: any): AuditLogModel[] {
    if (json) {
      return json.map((element: any) => new AuditLogModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      action: this.action,
      entity: this.entity,
      entityId: this.entityId,
      timestamp: this.timestamp,
      user: this.user,
    };
  }

  public getId() {
    return this.id?.toString() ?? '';
  }

  public getReference() {
    return this.id ?? '';
  }
}
